import {Basic} from 'types'

export const formatMoney = (
  cents: number | null | undefined,
  currency: Basic.Currency | undefined,
  options?: Intl.NumberFormatOptions
): string => {
  if (cents === null || cents === undefined) {
    return '-'
  }

  const amount: number = cents / 100

  const formatter = Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    ...options,
  })

  return formatter.format(amount)
}
